/*
|-------------------------------------------------------------------------------
| Vuex modules/dashboard.js
|-------------------------------------------------------------------------------
| Vuex data store for dashboard view
*/

// Import the `getField` getter and the `updateField`
// mutation function from the `vuex-map-fields` module.
import { getField, updateField } from 'vuex-map-fields';

export const dashboard = {
    namespaced: true,
    state: {
        isLoading: false,
        chartData: {
            hospital: null, // marketShareHospital
            pharmacy: null, // marketSharePharmacy
        },

        portfolios: [],
        productNames: [],
        substances: [],
        regions: [],
        forms: [],

        selected: {
            portfolios: [],
            productNames: [],
            substances: [],
            regions: [],
            forms: [],
        },
        
        products: {
            indications: {
                articles: [],
                headers: [
                    { text: 'Portfolio', value: 'portfolio' },
                    { text: 'Product name', value: 'product_name' },
                    { text: 'Form', value: 'form' },
                    { text: 'Indication', value: 'indication' },
                ],
            },
            guidelines: {
                articles: [],
                headers: [
                    { text: 'Portfolio', value: 'portfolio' },
                    { text: 'Guideline', value: 'guideline' },
                ],
            },
            sources: {
                articles: [],
                headers: [
                    { text: 'Portfolio', value: 'portfolio' },
                    { text: 'Sources', value: 'link' },
                ],
            },
            fass: {
                articles: [],
                headers: [
                    { text: 'Portfolio', value: 'portfolio' },
                    { text: 'Product name', value: 'product_name' },
                    { text: 'Approval date', value: 'launch_date' },
                    { text: 'Pack size', value: 'size' },
                    { text: 'Substance', value: 'substance' },
                    { text: 'Form', value: 'form' },
                    { text: 'VNR', value: 'vnr' },
                    { text: 'Fass', value: 'fass' },
                ],
            },
        },
    },
    getters: { getField },
    mutations: { updateField },
    actions: {
        /*
		    GET     /api/v1/products
	    */
        async getProducts({ commit }) {
            try {
                const {
                    data: { indications, guidelines, sources, fass },
                } = await DashboardAPI.products(this.selected);

                this.products.indications.articles = indications;
                this.products.guidelines.articles = guidelines;
                this.products.sources.articles = sources;
                this.products.fass.articles = fass;
            } catch (error) {
                console.error(error);
            }
        },
    },
};
